
import React from 'react'
import Layout from "../components/utils/layout";
import Filters from "./filters";
import NamedQueryModule from "../components/data_modules/named_query_module";
import Formatters from "../components/utils/formatters";

const Live = () => {
    const screenId="Live"
    const charts = {
        nickelodeon_card_orders : {
            source:"live"
        },
        referral_usage : {
            source:"live"
        },
        orders_by_source : {
            source:"live"
        }
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default Live